<div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
  <input
    [(ngModel)]="textTemplateSearchTerm"
    type="text"
    [appAutocomplete]="'/text_document_templates/autocomplete_by_name'"
    [data]="params"
    [include_item]="include_item"
    (autocompleteSelect)="textTemplateSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for text template'"
    class="form-control"
    [disabled]="!select_only && (!!textDocumentTemplateId || !editable)"
    name="text-template-search"
    ngDefaultControl
  />
  <div class="input-group-append" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!textDocumentTemplateId || !editable" (click)="clearSelectedTextTemplate()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
